module.exports = __webpack_public_path__ + "49e4f8dd4d0c1bebf5de732bcb93f9ab.svg";